import _ from 'lodash';

const unitFiltering = (params, user, units, canAnonymousFetchTimes, legalEntity, dedicated) => {
  const { inUnits, notInUnits } = params;

  // if dedicated units are used
  if (dedicated && (inUnits || notInUnits)) {
    let unitKeysToKeep;

    if (inUnits) {
      // get units that are not dedicated
      const filteredUnitKeys = inUnits.filter(u => u !== 'dedicated');

      // if => check if there is dedicated unit and add it to the list
      // else => otherwise just take filtered units
      if (inUnits.indexOf('dedicated') > -1) {
        unitKeysToKeep = [...filteredUnitKeys, dedicated[0]]; 
      } else {
        unitKeysToKeep = filteredUnitKeys;
      }
    } else if (notInUnits) {
      // exculude units from all units that are "notInUnits" list 
      unitKeysToKeep = _.keys(units).filter(unitKey => notInUnits.filter(n => n === unitKey).length === 0);
    }
    // exculude filtered units that are "notInUnits" list
    if (notInUnits) {
      unitKeysToKeep = _.keys(unitKeysToKeep).filter(unitKey => notInUnits.filter(n => n === unitKey).length === 0);
    }
    return unitKeysToKeep.reduce((obj, key) => ({ ...obj, [key]: units[key] }), {});
  }

  if (legalEntity) {
    return _.keys(units)
      .filter(unitKey => units[unitKey].legalUnit === legalEntity)
      .reduce((obj, key) => ({ ...obj, [key]: units[key] }), {});
  }
  // filter out units based on the selected path if the properties "inUnits" and "notInUnits" are present
  if (!inUnits && !notInUnits) {
    return units;
  }
  // If canAnonymousFetchTimes and no legalEntity is defined then do not filter units.
  if (canAnonymousFetchTimes && !legalEntity) {
    return units;
  }

  // Filter according to inUnits property
  if (inUnits) {
    const filteredUnitKeys = inUnits.filter(u => u !== 'dedicated');
    // NOTE: it has been decided to replace the 'dedicated' keyword with the user's home unit
    /*
    const respUnits = employers.map(e => e.respUnit);
    const sameRespUnit = respUnits.every(e => e === respUnits[0]);
    if (!sameRespUnit) {
      return null;
    }
    */
    if (inUnits.indexOf('dedicated') > -1 && user.dedicatedUnit) {
      // add the main employer unit
      // const homeUnit = user.employers.filter(e => e.mainEmployer).map(e => e.respUnit);
      filteredUnitKeys.push(user.dedicatedUnit);
    }
    return filteredUnitKeys.reduce((obj, key) => ({ ...obj, [key]: units[key] }), {});
  }
  // Filter according to notInUnits property
  console.log('filter out units');
  const unitKeysToKeep = _.keys(units).filter(unitKey => notInUnits.filter(n => n === unitKey).length === 0);
  return unitKeysToKeep.reduce((obj, key) => ({ ...obj, [key]: units[key] }), {});
};

export default {
  unitFiltering
};



// WEBPACK FOOTER //
// ./src/util/unitHelper.js